import { render, staticRenderFns } from "./Sellers.vue?vue&type=template&id=a2b52820&scoped=true&lang=pug"
import script from "./Sellers.vue?vue&type=script&lang=js"
export * from "./Sellers.vue?vue&type=script&lang=js"
import style0 from "./Sellers.vue?vue&type=style&index=0&id=a2b52820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b52820",
  null
  
)

export default component.exports